module.exports = __webpack_public_path__ + "static/media/DanLister@2x.d51442b5.png";